import { Accordion } from "../../../components/utilities";

const ServiceAgreementsWrapper = ({ children, gap = 1, ...rest }) => <Accordion defaultActiveKey="0" gap={gap} {...rest}>{children}</Accordion>

export default ServiceAgreementsWrapper;